<template>
  <div class="safe-footer-warp">
    <div class="safe-footer">
      <div class="safe-item">
        <div class="ico-bg flex-center">
          <Icon class="ico" name="safe" />
        </div>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle1 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent1 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <div class="ico-bg flex-center">
          <Icon class="ico" name="cart" />
        </div>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle2 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent2 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <div class="ico-bg flex-center">
          <Icon class="ico" name="tag-one" />
        </div>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle3 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent3 }}</p>
        </div>
      </div>
      <div class="safe-item">
        <div class="ico-bg flex-center">
          <Icon class="ico" name="time" />
        </div>
        <div class="safe-text">
          <p class="safe-title">{{ letter.footerSafeTitle4 }}</p>
          <p class="safe-content">{{ letter.footerSafeContent4 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  computed: {
    ...mapState({
      letter: state => state.letter,
      isLandscape: state => state.page.isLandscape
    })
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialTopupNew/officialTopupNew.scss';
.safe-footer-warp {
  .safe-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 40px;
    border-top: 1px solid #e3e3e3;
    border-bottom: 1px solid #e3e3e3;
    .safe-item {
      margin-top: 20px;
      display: flex;
      width: 270px;
      padding: 22px 0;

      .safe-text {
        margin-left: 18px;
        .safe-title {
          font-size: 34px;
          color: #333333;
        }
        .safe-content {
          margin-top: 10px;
          font-size: 20px;
          color: #999999;
        }
      }
      .ico-bg {
        flex-shrink: 0;
        background-color: rgb(0, 0, 0, 0.1);
        border-radius: 50%;
        width: 60px;
        height: 60px;
        .ico {
          width: 40px;
          height: 40px;
        }
      }
    }
  }
}
#ssr-page.landscape {
  .safe-footer-warp {
    position: relative;
    width: 100%;

    .safe-footer {
      height: unset;
      position: relative;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-column-gap: 18px;
      border: none;

      .safe-item {
        display: flex;
        margin-top: 0;
        margin-bottom: 36px;
        padding: 0;

        .safe-text {
          display: flex;
          flex-direction: column;
          align-items: start;
          margin-left: 10px;
          .safe-title {
            font-size: 16px;
            color: #f6f6f6;
          }
          .safe-content {
            margin-top: 10px;
            font-size: 14px;
            color: #f6f6f6;
          }
        }
        .ico-bg {
          background-color: rgb(255, 255, 255, 0.1);
          border-radius: 50%;
          width: 48px;
          height: 48px;
          .ico {
            width: 32px;
            height: 29px;
          }
        }
      }
    }
  }
}
</style>
